import Notiflix from 'notiflix';
import React, { useContext, useEffect, useState } from 'react'
import { IoClose, IoSearch } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import GetApiCall from '../../Helper/GetApi';
import PostApiCall from '../../Helper/PostApi';
import { store } from '../../Helper/Context/Store';

const SearchBar = () => {
    const [suggestionPro, setSuggestionPro] = useState([]);
      const [seachBar, setseachBar] = useState(false);
      const {setShowSearchBar, showSearchBar} = useContext(store)

      const [seachData, setSeachData] = useState([]);
  const [searchText, setSearchText] = useState("");


    useEffect(() => {
        SearchVariantByProduct();
        getSuggestionProducts();
        // eslint-disable-next-line
      }, []);
      const getSuggestionProducts = () => {
        GetApiCall.getRequest("GetHomepageSetup").then((resultdes) =>
          resultdes.json().then((obj) => {
            // setHomePageSetup(obj.data);
            obj.data
              .filter((value) => value.fld_section_name === "Featured Products")
              .forEach((filtereddata) => {
                PostApiCall.postRequest(
                  {
                    sectionname: filtereddata.fld_section_name,
                    itemchoice: filtereddata.fld_item_choice,
                  },
                  "GetWebsiteHomePageItems"
                ).then((results) => {
                  if (results.status === 200 || results.status === 201) {
                    results.json().then((data) => {
                      // setHeading1(filtereddata.fld_headline1)
                      // setHeading2(filtereddata.fld_headline2)
                      setSuggestionPro(data.data);
                    });
                  }
                });
              });
          })
        );
      };
      const SearchVariantByProduct = () => {
        Notiflix.Loading.circle();
        PostApiCall.postRequest(
          {
            variantName: "",
          },
          "SearchVariantByProduct"
        )
          .then((res) => res.json())
          .then((res1) => {
            if (res1.data) {
              setSeachData(res1.data);
              Notiflix.Loading.remove();
            }
          });
      };
  return (<>
  <div
            className={
                showSearchBar === true
                ? "searchbar-main-active searchbar-main"
                : "searchbar-main"
            }>
            <div className="searchbar-input">
              <div className="box">
                <IoSearch />
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    // setseachResult(true);
                  }}
                  placeholder="Search"
                />
                <IoClose
                  onClick={() => {
                    setSearchText("");
                    // setseachBar(false);
                    setShowSearchBar(false);
                  }}
                />
              </div>
            </div>
            <div
              className={
                searchText === "" ? "results row" : "results-active results row"
              }>
              <div className="col-lg-4 d-none d-lg-block">
                <h5 className="border-bottom pb-2">Suggestions</h5>
                {suggestionPro.length > 0 &&
                  suggestionPro.map((data, index) => {
                    return (
                      <div key={index} className="mb-4 cusror-pointer">
                        <Link
                          onClick={() => {
                            setShowSearchBar(false);
                            setSearchText("");
                          }}
                          to={`/p/${data.fld_route}`}
                          // to={`/productdetail/${data.fld_variantname?.replace(
                          //   /\s/g,
                          //   "-"
                          // )}-${data.fld_variantname?.replace(/\s/g, "-")}/${data.fld_variantid
                          //   }`}
                        >
                          <div className="produst-card">
                            <div className="img">
                              <img
                                alt={data.fld_variantname}
                                src={data.VariantImage}
                                className="img-fluid"
                              />
                            </div>
                            <div className="content">
                              <p>{data.fld_variantname}</p>
                              <div className="price">
                                &#x20B9; {data.fld_selling_price}{" "}
                                {data.fld_mrp > data.fld_selling_price && (
                                  <del>&#x20B9; {data.fld_mrp}</del>
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
              <div className="col-lg-8">
                <h5 className="border-bottom pb-2">Products</h5>
                <div className="row">
                  {seachData
                    ?.filter((dat) =>
                      dat.SearchData.toLowerCase().includes(
                        searchText.toLowerCase()
                      )
                    )
                    .map((data, index) => {
                      return (
                        <div
                          key={index}
                          className="col-lg-6 mb-4 cusror-pointer">
                          <Link
                            onClick={() => {
                              setShowSearchBar(false);
                              setSearchText("");
                            }}
                            to={`/p/${data.fld_route}`}
                            // to={`${process.env.PUBLIC_URL
                            //   }/p/${data.fld_route?.replace(
                            //     /\s/g,
                            //     "-"
                            //   ).replace('/', '')}`}
                          >
                            <div className="produst-card">
                              <div className="img">
                                <img
                                  alt={data.fld_variantname}
                                  src={data.fld_imageurl}
                                  className="img-fluid"
                                />
                              </div>
                              <div className="content">
                                <p>{data.fld_variantname}</p>
                                <div className="price">
                                  &#x20B9; {data.fld_selling_price}{" "}
                                  {data.fld_mrp > data.fld_selling_price && (
                                    <del>&#x20B9; {data.fld_mrp}</del>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div
              className="serach-close"
              onClick={() => {
                setShowSearchBar(false);
                setSearchText("");
              }}></div>
          </div>
  </>
  )
}

export default SearchBar